export const RegionAction = {
    LOAD: 'LOAD',
    AUTOCOMPLETE: 'AUTOCOMPLETE',
};

export const RegionMutation = {
    REQUEST: 'REQUEST',
    SUCCESS: 'SUCCESS',
    SUCCESS_AUTOCOMPLETE: 'SUCCESS_AUTOCOMPLETE',
    ERROR: 'ERROR',
};